import React, { useEffect, useRef } from 'react';
import { initializePlayer } from '../../../helpers/youtubeHelper';

interface VideoProps {
  assetId: string
  videoId: string;
  autoPlayFlag: number;
}

const Video = ({ assetId, videoId, autoPlayFlag }: VideoProps) => {
  const playerRef = useRef<YT.Player | null>(null);

  useEffect(() => {
    if (window.YT) {
      playerRef.current = initializePlayer(assetId, videoId, autoPlayFlag);
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [assetId, videoId, autoPlayFlag]);

  return (
    <div className="pd-cover-parent pd-flex pd-items-center pd-justify-center pd-bg-dim-100">
      <div id={`video-player-${assetId}`} className="pd-aspect-video" />
    </div>
  );
};

export default Video;
